import { CommonModule } from '@angular/common';
import { ANALYZE_FOR_ENTRY_COMPONENTS, NgModule } from '@angular/core';
import { ROUTES } from '@angular/router';
import {
  DYNAMIC_COMPONENT,
  JssModule,
} from '@sitecore-jss/sitecore-jss-angular';
import { SharedModule } from '../shared/shared.module';

import { Title } from '@angular/platform-browser';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { ConnectionErrorComponent } from './components/sentoo-transfer/connection-error/connection-error.component';
import { PaymentCancelledComponent } from './components/sentoo-transfer/payment-cancelled/payment-cancelled.component';
import { PaymentExpiredComponent } from './components/sentoo-transfer/payment-expired/payment-expired.component';
import { PaymentScreenComponent } from './components/sentoo-transfer/payment-screen/payment-screen.component';
import { SentooTransferComponent } from './components/sentoo-transfer/sentoo-transfer/sentoo-transfer.component';
import { ValidatePaymentComponent } from './components/sentoo-transfer/validate-payment/validate-payment.component';
import { LandingComponent } from './components/sentoo/landing/landing.component';
import { PaymentCompleteComponent } from './components/sentoo/payment-complete/payment-complete.component';
import { PaymentInvalidComponent } from './components/sentoo/payment-invalid/payment-invalid.component';
import { PaymentPendingComponent } from './components/sentoo/payment-pending/payment-pending.component';
import { SentooComponent } from './components/sentoo/sentoo/sentoo.component';

const SentooComponents = [
  { name: 'Sentoo', type: SentooComponent },
  { name: 'SentooTransfer', type: SentooTransferComponent },
  { name: 'Landing', type: LandingComponent },
  { name: 'PaymentInvalid', type: PaymentInvalidComponent },
  { name: 'ConnectionError', type: ConnectionErrorComponent },
  { name: 'PaymentCancelled', type: PaymentCancelledComponent },
  { name: 'PaymentComplete', type: PaymentCompleteComponent },
  { name: 'PaymentExpired', type: PaymentExpiredComponent },
  { name: 'PaymentPending', type: PaymentPendingComponent },
  { name: 'PaymentScreen', type: PaymentScreenComponent },
  { name: 'ValidatePayment', type: ValidatePaymentComponent },
];

const ProviderArray = {};

SentooComponents.forEach((component) => {
  ProviderArray[component.name] = component.type;
});

@NgModule({
  declarations: [
    LandingComponent,
    ConnectionErrorComponent,
    SentooComponent,
    PaymentInvalidComponent,
    SentooTransferComponent,
    PaymentCancelledComponent,
    PaymentExpiredComponent,
    PaymentCompleteComponent,
    PaymentPendingComponent,
    PaymentScreenComponent,
    ValidatePaymentComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgbPaginationModule,
    {
      ngModule: JssModule,
      providers: [
        {
          provide: ROUTES,
          useValue: [],
          multi: true,
        },
        {
          provide: DYNAMIC_COMPONENT,
          useValue: ProviderArray,
        },
        {
          provide: ANALYZE_FOR_ENTRY_COMPONENTS,
          useValue: SentooComponents,
          multi: true,
        },
      ],
    },
  ],
  providers: [Title],
  exports: [],
})
export class SentooModule {}

export { SentooComponents };
